var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 34,
    viewBox: "0 0 138 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.26477,
    y: 0.708129,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7394,
    y: 0.708129,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 35.214,
    y: 0.708129,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.26477,
    y: 17.6534,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.7394,
    y: 17.6534,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35.214,
    y: 17.6534,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5529,
    y: 0.708129,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0275,
    y: 0.708129,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 87.5031,
    y: 0.708129,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 52.5529,
    y: 17.6534,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 70.0275,
    y: 17.6534,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 87.5031,
    y: 17.6534,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 104.841,
    y: 0.708129,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 122.317,
    y: 0.708129,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 104.841,
    y: 17.6534,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 122.317,
    y: 17.6534,
    width: 15.3566,
    height: 15.3566,
    rx: 2.38293,
    stroke: "#C3C3C3",
    strokeWidth: 0.52954
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD8);
export default __webpack_public_path__ + "static/media/d8.d71928ad570841c1e4c1ca72b0921842.svg";
export { ForwardRef as ReactComponent };